<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
            <table class="table main-table">
                <thead>
                    <tr>
                        <th> Category </th>
                        <th> Offer</th>
                        <th> ELP Keyword </th>
                        <th> SRP </th>
                        <th> Description </th>
                        <th> Validity </th>
                        <th> Date Updated </th>
                        <th> Status </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td colspan="7">
                            <div class="text-center">
                                <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!loading && pageItems.length == 0">
                        <td colspan="7">
                            <div class="text-center">
                                <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                                <p class="text-xs font-weight-bold">No Data Found</p>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(product, index) in pageItems" :key="index">
                        <td>
                            <p class="sub-text"> {{ product.brand }}</p>
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text"> {{ product.offer }}</p>
                                <sub class="text-muted"> {{ product.family }}</sub>
                            </div>
                        </td>
                        <td>
                            <p class="sub-text">
                                {{ product.keywordDisplay }}
                            </p>
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info" v-if="product.srp > 0">
                                Php {{ product.srp.toFixed(2) }}
                            </span>
                            <span class="badge badge-sm bg-gradient-info" v-if="product.srp == 0">-</span>
                        </td>
                        <td>
                            <div style="max-width: 500px;" class="text-wrap">
                                <p class="sub-text">
                                    {{ product.description }}
                                </p>
                            </div>
                        </td>
                        <td>
                            <p class="sub-text">
                                {{ product.validity }} Days
                            </p>
                        </td>
                        <td>
                            <p class="sub-text">
                                {{ $format.FormatFullDateTime(product.dateUpdated) }}
                            </p>
                        </td>
                        <td class="align-middle">
                            <label class="switch">
                                <input type="checkbox" :checked="product.isVisible"
                                    @click.prevent="onToggleStatus(product)" />
                                <span class="slider round"></span>
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="paginate-div d-flex align-items-end mt-3 me-3">
            <vue-awesome-paginate class="ms-auto" :max-pages-shown="5" :total-items="filteredProducts.length"
                :items-per-page="itemPerPage" :on-click="onPageChanged" v-model="currentPage" />
        </div>
    </div>
    <GlobalModal :show="showGlobalModal" :type="globalModalType" @close="showGlobalModal = false"
        @confirm="handleConfirm" @cancel="handleCancel" />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";
import GlobalModal from '@/components/GlobalModal.vue';

export default {
    data() {
        return {
            noDataJSON,
            searchingJSON,
            itemPerPage: 20,
            pageItems: [],
            showGlobalModal: false,
            globalModalType: "success",
            selectedProduct: null,
            originalIsVisible: null,
        };
    },
    components: { GlobalModal },
    computed: {
        ...mapState({
            currentPage: (state) => state.productController.currentPage,
            loading: (state) => state.productController.loading,
            products: (state) => state.productController.filteredProducts,
        }),
        filteredProducts() {
            const excludedCategories = [];
            return this.products.filter(
                product => !excludedCategories.includes(product.categoryCode)
            );
        },
    },
    watch: {
        products: {
            handler() {
                this.onPageChanged(1);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions({
            getProducts: "productController/GetProducts",
            updateProductStatus: "productController/UpdateProductStatus",
        }),
        ...mapMutations({
            setCurrentPage: "productController/SET_CurrentPage"
        }),
        onPageChanged(page) {
            this.setCurrentPage(page);

            this.pageItems = this.filteredProducts.slice(
                (this.currentPage - 1) * this.itemPerPage,
                this.currentPage * this.itemPerPage
            );
        },
        onToggleStatus(product) {
            this.selectedProduct = product;
            this.originalIsVisible = product.isVisible;
            this.globalModalType = "confirmation";
            this.showGlobalModal = true;
        },
        async handleConfirm() {
            const isVisible = !this.originalIsVisible;
            const productID = this.selectedProduct.productID;
            const bundleID = this.selectedProduct.bundleID;

            const payload = { productID, bundleID, isVisible };

            let result;
            try {
                result = await this.$store.dispatch('productController/UpdateProductStatus', payload);
            } catch (e) {
                result = false;
            }

            if (result === false) {
                this.globalModalType = "error";
                this.showGlobalModal = true;
            }
            
            await this.getProducts(); // Refresh list

            this.selectedProduct = null;
            this.originalIsVisible = null;
        },
        handleCancel() {
            this.showGlobalModal = false;
            this.selectedProduct = null;
            this.originalIsVisible = null;
        },
    },
    async mounted() {
        await this.getProducts();
    },
};
</script>